import React, { useEffect, useState, useRef, useCallback, createContext } from "react";
import { Col, Row } from "react-bootstrap";
import "./Spot.css";
import LeftTable from "./LeftTable";
import RightTable from "./RightTable";
import BuyAndSell from "./BuyAndSell";
import BottomTable from "./BottomTable";
import SpotChart from "./SpotChart";
import QuickSwap from "./QuickSwap";
import TopMovers from "./TopMovers";
import SpotLayoutDrawer from "./SpotLayoutDrawer";
import SpotTickerMarquee from "./SpotTickerMarquee";
import { syncExchangeSettingsOnLoad } from "./exchangeSettingsService";
import { setSpotLayoutPreset } from "./spotLayoutConfig";
import { setTradingColorPreference } from "./tradingColorConfig";
import {
  SPOT_COMPONENTS,
  getSpotLayoutMatrix,
  saveSpotLayoutMatrix,
  DEFAULT_SPOT_LAYOUT_MATRIX,
} from "./spotLayoutConfig";
import { useTradingColors } from "./tradingColorConfig";

import axios from "axios";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import FlipNumbers from "react-flip-numbers";

import { useLocation, useNavigate, Link } from "react-router-dom";
import { checkInternetConnection, ASSETICONBASEURL } from "../../CoreDataService";
import { Box, Paper, Typography, Tooltip, IconButton, alpha } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import { useSelector } from "react-redux";
import { isSupportedCoinPriceAsset, getCoinPriceSlug, getCoinPriceDisplayName } from "../CoinPrice/coinMapConstants";


export const DataContext = createContext();

const Spot = () => {
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const { upColor, downColor } = useTradingColors();
  const [isConnected, setIsConnected] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const pageName = location.pathname.split("/").pop();
  const [isLayoutDrawerOpen, setIsLayoutDrawerOpen] = useState(false);


  const [chartData, setChartData] = useState(null);
  const [ltp, setLtp] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [updateBalance, setUpdateBalance] = useState(false);
  const [updateOrder, setUpdateOrder] = useState(false);

  const [rocData, setRocData] = useState(0);
  const [volumnData, setVolumnData] = useState(0);
  const [lowPrice, setLowPrice] = useState(0);
  const [highPrice, setHighPrice] = useState(0);

  const [isNegative, setIsNegative] = useState(false);
  const [finalBiddata, setFinalBiddata] = useState([]);
  const [finalAskdata, setFinalAskdata] = useState([]);
  const [lastAskItem, setLastAskItem] = useState(null);
  const [firstBidItem, setFirstBidItem] = useState(null);
  const [sellData, setSellData] = useState("");
  const [buyData, setBuyData] = useState("");
  // Parse pair from URL search string (e.g., /spot?BTC-USDT)
  const pairFromUrl = location.search ? location.search.substring(1) : null;
  const [initialCurrency, initialBase] =
    pairFromUrl && pairFromUrl.includes("-")
      ? pairFromUrl.split("-").map((s) => s.toUpperCase())
      : [
        (localStorage.getItem("buying_crypto_asset") || "BTC")?.toUpperCase(),
        (
          localStorage.getItem("selling_crypto_asset") || "USDT"
        )?.toUpperCase(),
      ];

  const [currencycode, setCurrencycode] = useState(initialCurrency);
  const [basecurrency, setBasecurrency] = useState(initialBase);

  const [isFavorite, setIsFavorite] = useState(() => {
    try {
      const favs = JSON.parse(localStorage.getItem("favorite_pairs") || "[]");
      return favs.includes(`${initialCurrency}_${initialBase}`) || favs.includes(`${initialCurrency}/${initialBase}`);
    } catch (e) {
      return false;
    }
  });

  useEffect(() => {
    try {
      const favs = JSON.parse(localStorage.getItem("favorite_pairs") || "[]");
      setIsFavorite(favs.includes(`${currencycode}_${basecurrency}`) || favs.includes(`${currencycode}/${basecurrency}`));
    } catch (e) {
      setIsFavorite(false);
    }
  }, [currencycode, basecurrency]);

  const toggleFavorite = (e) => {
    e.stopPropagation();
    try {
      const key = `${currencycode}_${basecurrency}`;
      let favs = JSON.parse(localStorage.getItem("favorite_pairs") || "[]");
      if (favs.includes(key)) {
        favs = favs.filter((f) => f !== key);
        setIsFavorite(false);
      } else {
        favs.push(key);
        setIsFavorite(true);
      }
      localStorage.setItem("favorite_pairs", JSON.stringify(favs));
      window.dispatchEvent(new Event("favorite_pairs_updated"));
    } catch (err) {}
  };
  const stompClientRef = useRef(null); // Store the Stomp client instance
  const allProps = {
    chartData,
    setFinalBiddata,
    setFinalAskdata,
    setCurrencycode,
    setBasecurrency,
    currencycode,
    basecurrency,
    lowPrice,
    highPrice,
    setSellData,
    setBuyData,
    finalBiddata,
    finalAskdata,
    lastAskItem,
    firstBidItem,
    setLastAskItem,
    setFirstBidItem,
    ltp,
    setRefresh,
    refresh,
    updateBalance,
    sellData,
    buyData,
    setUpdateBalance,
    updateOrder,
    setUpdateOrder,
  };
  const reqNo = Math.floor(Math.random() * 1000) + 1;
  const webSocketEndPoint = "https://stream.paybito.com/SocketStream/ws";
  const topicForBtcUsd = "/topic/stream/BTCUSD";
  const topic = "/user/topic/stream";

  // Update URL when pair changes
  useEffect(() => {
    const pair = `${currencycode}-${basecurrency}`;
    navigate(`/spot?${pair}`, { replace: true });
  }, [currencycode, basecurrency]);

  useEffect(() => {
    const spotPageTitle = `${chartData?.ltp
      } | ${currencycode.toUpperCase()}${basecurrency.toUpperCase()} | ${localStorage.getItem(
        "exchange"
      )} Spot`;

    if (pageName && pageName.toLowerCase() === "spot") {
      document.title = spotPageTitle;
      return;
    }
  }, [pageName, chartData]);
  console.log("Chart data in Spot component:");

  const _connect = () => {
    if (localStorage.getItem("access_token")) {
      const socket = new SockJS(webSocketEndPoint);
      stompClientRef.current = Stomp.over(socket);
      stompClientRef.current.debug = null; // Disable debug logging

      stompClientRef.current.connect(
        {},
        (frame) => {
          let topicToSubscribe =
            currencycode?.toUpperCase() === "BTC" &&
              basecurrency?.toUpperCase() === "USD"
              ? topicForBtcUsd
              : topic;

          if (stompClientRef.current && stompClientRef.current.connected) {
            stompClientRef.current.subscribe(topicToSubscribe, (sdkEvent) => {
              onMessageReceived(sdkEvent);
            });
            subscribe(); // Ensure this doesn't rely on an unready connection
          } else {
            console.error("STOMP connection not ready yet.");
          }
        },
        errorCallBack
      );
    } else {
      console.log("Access token is not available");
    }
  };

  const _disconnect = () => {
    if (stompClientRef.current && stompClientRef.current.connected) {
      stompClientRef.current.disconnect(() => {
        console.log("Disconnected");
      });
    } else {
      console.warn("Disconnect skipped: STOMP client not connected.");
    }
  };

  const errorCallBack = (error) => {
    if (localStorage.getItem("access_token") !== null) {
      setTimeout(() => {
        _connect();
      }, 5000);
    }
  };

  const _send = (message) => {
    if (!stompClientRef.current || !stompClientRef.current.connected) {
      console.error("WebSocket is not connected yet.");
      return;
    }

    const sendMessage = {
      method: "SUBSCRIBE",
      params: [
        `${currencycode.toLowerCase()}/${basecurrency.toLowerCase()}@ticker`,
        `${currencycode.toLowerCase()}${basecurrency.toLowerCase()}@depth`,
        `${currencycode.toLowerCase()}${basecurrency.toLowerCase()}@trade`,
      ],
      id: reqNo,
    };

    stompClientRef.current.send(
      currencycode.toUpperCase() === "BTC" &&
        basecurrency.toUpperCase() === "USD"
        ? "/app/sendRequest/BTCUSD"
        : "/app/sendRequest",
      {},
      JSON.stringify(sendMessage)
    );
  };

  const onMessageReceived = (message) => {
    const parsedMessage = JSON.parse(message.body);
    const data = parsedMessage.tR;
    if (data !== null) {
      setChartData(data);
      setLowPrice(parseFloat(data?.lowPrice).toFixed(2));
      setHighPrice(parseFloat(data?.highPrice).toFixed(2));

      setRocData(parseFloat(data?.roc).toFixed(2));
      setVolumnData(parseFloat(data?.volume).toFixed(2));
      setIsNegative(data?.roc < 0);
    }
  };

  useEffect(() => {
    // Call the function and get the cleanup function
    const cleanup = checkInternetConnection(setIsConnected);

    // Cleanup listeners when component unmounts
    return () => cleanup();
  }, []);


  const subscribe = () => {
    if (currencycode && basecurrency) {
      const req = {
        method: "SUBSCRIBE",
        params: [
          `${currencycode.toLowerCase()}/${basecurrency.toLowerCase()}@ticker`,
          `${currencycode.toLowerCase()}${basecurrency.toLowerCase()}@depth`,
          `${currencycode.toLowerCase()}${basecurrency.toLowerCase()}@trade`,
        ],
        id: reqNo,
      };
      setTimeout(() => {
        _send(req);
      }, 10000);
      localStorage.setItem("isUnsubscribeOccured", "false");
    }
  };

  useEffect(() => {
    const fetchTickerData = () => {
      const buyingCryptoAsset = currencycode;
      const sellingCryptoAsset = basecurrency;

      axios
        .get(
          `https://stream.paybito.com/SocketStream/api/get24hTicker?counter=${buyingCryptoAsset}&base=${sellingCryptoAsset}`,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        )
        .then((response) => {
          const result = response.data;
          if (result && result.length) {
            const data = result[0];
            setChartData(data);
            setLtp(data?.ltp);
            setLowPrice(parseFloat(data.lowPrice).toFixed(2));
            setHighPrice(parseFloat(data.highPrice).toFixed(2));
            setRocData(parseFloat(data.roc).toFixed(2));
            setVolumnData(parseFloat(data.volume).toFixed(2));
            setIsNegative(data.roc < 0);
          }
          _disconnect(); // Disconnect before connecting again
          _connect();
        })
        .catch((error) => {
          console.error("Error fetching 24h ticker data manually:", error);
        });
    };

    fetchTickerData();

    return () => {
      // Prevent disconnect if client isn't ready
      _disconnect();
    };
  }, [basecurrency, currencycode]);

  const [layoutMatrix, setLayoutMatrix] = useState(() => getSpotLayoutMatrix());
  const [rowHeights, setRowHeights] = useState({ "main-trading-row": 882 });
  const observerRef = useRef(null);

  const measureElementContentHeight = (el) => {
    if (!el) return 0;
    const masterColEl = el.dataset?.rowKey ? el : el.closest?.("[data-row-key]");
    const targetEl = masterColEl || el;

    if (targetEl.children && targetEl.children.length > 0) {
      let totalH = 0;
      for (let i = 0; i < targetEl.children.length; i++) {
        const child = targetEl.children[i];
        const style = window.getComputedStyle(child);
        const mt = parseFloat(style.marginTop) || 0;
        const mb = parseFloat(style.marginBottom) || 0;
        totalH += child.offsetHeight + mt + mb;
      }
      if (totalH >= 500) {
        return Math.round(totalH);
      }
    }
    return targetEl.offsetHeight >= 500 ? targetEl.offsetHeight : 0;
  };

  const registerMasterRef = useCallback((rowKey, el) => {
    if (!observerRef.current) {
      observerRef.current = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const target = entry.target;
          const key = target.dataset?.rowKey || target.closest?.("[data-row-key]")?.dataset?.rowKey;
          if (key) {
            const h = measureElementContentHeight(target);
            if (h >= 500) {
              setRowHeights((prev) => (prev[key] === h ? prev : { ...prev, [key]: h }));
            }
          }
        }
      });
    }
    if (el) {
      el.dataset.rowKey = rowKey;
      observerRef.current.observe(el);
      if (el.children && el.children.length > 0) {
        for (let i = 0; i < el.children.length; i++) {
          const child = el.children[i];
          child.dataset.rowKey = rowKey;
          observerRef.current.observe(child);
        }
      }
      const initialH = measureElementContentHeight(el);
      if (initialH >= 500) {
        setRowHeights((prev) => (prev[rowKey] === initialH ? prev : { ...prev, [rowKey]: initialH }));
      }
    }
  }, []);

  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  // Dynamically sync user's active layout & color with broker settings on load
  useEffect(() => {
    const currentPreset = localStorage.getItem("admin_spot_layout_preset") || "DEFAULT";
    const currentColor = localStorage.getItem("spot_color_preference") || "FRESH";
    syncExchangeSettingsOnLoad({
      currentPresetId: currentPreset,
      onSetPreset: (presetId) => {
        setSpotLayoutPreset(presetId);
      },
      currentColorId: currentColor,
      onSetColor: (colorId) => {
        setTradingColorPreference(colorId);
      },
    });
  }, []);

  useEffect(() => {
    const handleLayoutUpdate = (event) => {
      if (event.detail && Array.isArray(event.detail)) {
        setLayoutMatrix(event.detail);
      } else {
        setLayoutMatrix(getSpotLayoutMatrix());
      }
    };
    window.addEventListener("spot_layout_change", handleLayoutUpdate);
    return () => {
      window.removeEventListener("spot_layout_change", handleLayoutUpdate);
    };
  }, []);

  const renderDashboardComponent = (componentKey, compConfig = {}) => {
    switch (componentKey) {
      case SPOT_COMPONENTS.ORDER_BOOK:
        return <LeftTable />;
      case SPOT_COMPONENTS.TRADE_HISTORY:
        return <RightTable {...(compConfig?.props || {})} />;
      case SPOT_COMPONENTS.CHART:
        return <SpotChart />;
      case SPOT_COMPONENTS.BUY_SELL:
        return <BuyAndSell />;
      case SPOT_COMPONENTS.BOTTOM_TABLE:
        return <BottomTable />;
      case SPOT_COMPONENTS.QUICK_SWAP:
        return <QuickSwap />;
      case SPOT_COMPONENTS.TOP_MOVERS:
        return <TopMovers {...(compConfig?.props || {})} />;
      default:
        return null;
    }
  };

  return (
    <DataContext.Provider value={allProps}>
      <Box sx={pageWrapper}>
        {/* ── Ticker Strip ── */}
        <Box sx={tickerStrip}>
          <Box sx={tickerTopRow}>
            {/* Left — Pair badge */}
            <Box sx={tickerPairBadge}>
            <Box sx={tickerPairIconWrap}>
              <Box
                component="img"
                src={`${ASSETICONBASEURL}${currencycode.toUpperCase()}.png`}
                alt={currencycode}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  if (e.currentTarget.nextSibling) {
                    e.currentTarget.nextSibling.style.display = "block";
                  }
                }}
                sx={{ width: 20, height: 20, borderRadius: "50%", objectFit: "contain" }}
              />
              <ShowChartOutlinedIcon sx={{ fontSize: 15, color: "#fff", display: "none" }} />
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <Typography sx={tickerPairText}>
                  {currencycode.toUpperCase()}
                  <span style={{ opacity: 0.45, fontWeight: 400 }}>
                    /{basecurrency.toUpperCase()}
                  </span>
                </Typography>
                <Tooltip title={isFavorite ? "Remove from Favorites (View in Market Pairs ★ tab)" : "Add to Favorites (View in Market Pairs ★ tab)"}>
                  <IconButton
                    size="small"
                    onClick={toggleFavorite}
                    sx={{
                      color: isFavorite ? "#f0b90b" : "rgba(125,125,125,0.45)",
                      p: "2px",
                      transition: "all 0.15s ease",
                      "&:hover": { color: "#f0b90b", transform: "scale(1.15)" },
                    }}
                  >
                    {isFavorite ? (
                      <StarIcon sx={{ fontSize: 16, color: "#f0b90b" }} />
                    ) : (
                      <StarBorderIcon sx={{ fontSize: 16 }} />
                    )}
                  </IconButton>
                </Tooltip>
              </Box>
              {/* Binance-style clickable [Coin Name] Price link */}
              {isSupportedCoinPriceAsset(currencycode) ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <Link
                    to={`/price/${getCoinPriceSlug(currencycode)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#f0b90b",
                      fontSize: "11px",
                      fontWeight: 500,
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "2px",
                      lineHeight: 1.2,
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.textDecoration = "underline")}
                    onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
                  >
                    <span>{getCoinPriceDisplayName(currencycode)} Price</span>
                    <span style={{ fontSize: "11px", marginLeft: "1px" }}>›</span>
                  </Link>
                </Box>
              ) : (
                <Typography sx={tickerPairSub}>Spot</Typography>
              )}
            </Box>
          </Box>

          {/* Center — Stats */}
          <Box sx={tickerStatsCenter}>
            <Box sx={tickerDivider} />

            {/* Last Price */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>LAST PRICE</Typography>
              <Typography
                sx={{
                  ...tickerStatValue,
                  color: isNegative ? downColor : upColor,
                  fontWeight: 800,
                  fontSize: "1rem",
                }}
              >
                <FlipNumbers
                  height={14}
                  width={9}
                  play
                  duration={2}
                  numbers={Number(chartData?.ltp).toLocaleString(undefined, {
                    minimumFractionDigits: 6,
                    maximumFractionDigits: 6,
                  })}
                />
              </Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Change */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H CHANGE</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                {isNegative ? (
                  <TrendingDownOutlinedIcon
                    sx={{ fontSize: 13, color: downColor }}
                  />
                ) : (
                  <TrendingUpOutlinedIcon
                    sx={{ fontSize: 13, color: upColor }}
                  />
                )}
                <Typography
                  sx={{
                    ...tickerStatValue,
                    color: isNegative ? downColor : upColor,
                  }}
                >
                  {rocData}%
                </Typography>
              </Box>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Volume (Base Asset) */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>
                24H VOL ({currencycode.toUpperCase()})
              </Typography>
              <Typography sx={tickerStatValue}>
                {chartData?.ltp && parseFloat(chartData.ltp) > 0
                  ? (parseFloat(String(volumnData).replace(/,/g, "")) / parseFloat(chartData.ltp)).toFixed(2)
                  : volumnData}
              </Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Volume (Quote Asset) */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>
                24H VOL ({basecurrency.toUpperCase()})
              </Typography>
              <Typography sx={tickerStatValue}>{volumnData}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H High */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H HIGH</Typography>
              <Typography sx={{ ...tickerStatValue, color: upColor }}>
                {highPrice}
              </Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Low */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H LOW</Typography>
              <Typography sx={{ ...tickerStatValue, color: downColor }}>
                {lowPrice}
              </Typography>
            </Box>

            <Box sx={tickerDivider} />
          </Box>

          {/* Right — Connection status */}
          <Box sx={tickerConnectionWrap}>
            {/* Layout Setting button just before the LIVE badge */}
            <Tooltip title="Layout Settings" placement="bottom">
              <IconButton
                size="small"
                onClick={() => setIsLayoutDrawerOpen(true)}
                sx={{
                  color: isLayoutDrawerOpen ? (btncolor || "#F0B90B") : "var(--text-color)",
                  opacity: isLayoutDrawerOpen ? 1 : 0.8,
                  mr: 1,
                  p: "5px",
                  borderRadius: "6px",
                  border: isLayoutDrawerOpen
                    ? `1px solid ${btncolor || "#F0B90B"}`
                    : "1px solid rgba(125,125,125,0.22)",
                  backgroundColor: isLayoutDrawerOpen
                    ? alpha(btncolor || "#F0B90B", 0.12)
                    : "rgba(125,125,125,0.08)",
                  transition: "all 0.15s ease",
                  "&:hover": {
                    opacity: 1,
                    color: btncolor || "#F0B90B",
                    borderColor: alpha(btncolor || "#F0B90B", 0.4),
                    backgroundColor: alpha(btncolor || "#F0B90B", 0.12),
                  },
                }}
              >
                <TuneIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>

            <Box sx={tickerConnectionPill}>
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  flexShrink: 0,
                  backgroundColor: isConnected ? upColor : downColor,
                  boxShadow: isConnected
                    ? `0 0 5px ${upColor}`
                    : `0 0 5px ${downColor}`,
                  animation: isConnected
                    ? "tickerPulse 2s ease-in-out infinite"
                    : "none",
                }}
              />
              <Typography
                sx={{
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  color: isConnected ? upColor : downColor,
                  letterSpacing: "0.06em",
                }}
              >
                {isConnected ? "LIVE" : "OFFLINE"}
              </Typography>
            </Box>
          </Box>
        </Box>

          {/* Bottom of this section: Moving Ticker Marquee */}
          <SpotTickerMarquee />
        </Box>

        {/* ── Main Trading Layout (Rendered from Static Matrix) ── */}
        <Box sx={tradingLayout}>
          {layoutMatrix.map((rowConfig, rIdx) => {
            const rowKey = rowConfig.rowId || `row-${rIdx}`;
            const isTableOnlyCol = (col) =>
              col.components.every(
                (c) =>
                  c.key === SPOT_COMPONENTS.ORDER_BOOK ||
                  c.key === SPOT_COMPONENTS.TRADE_HISTORY
              );
            const hasMultipleCols = rowConfig.columns && rowConfig.columns.length > 1;
            const hasTableCol = hasMultipleCols && rowConfig.columns.some(isTableOnlyCol);
            const hasChartAndBuySellInRow = rowConfig.columns && rowConfig.columns.some(
              (col) =>
                col.components.some((c) => c.key === SPOT_COMPONENTS.CHART) &&
                col.components.some((c) => c.key === SPOT_COMPONENTS.BUY_SELL)
            );
            const masterCol = hasTableCol
              ? rowConfig.columns.find(
                  (col) =>
                    col.components.some((c) => c.key === SPOT_COMPONENTS.CHART) &&
                    col.components.some((c) => c.key === SPOT_COMPONENTS.BUY_SELL)
                ) ||
                rowConfig.columns.find(
                  (col) =>
                    col.components.some((c) => c.key === SPOT_COMPONENTS.BUY_SELL) &&
                    col.components.length > 1
                ) ||
                rowConfig.columns.find(
                  (col) =>
                    col.components.some((c) => c.key === SPOT_COMPONENTS.CHART) &&
                    !col.components.some((c) => c.key === SPOT_COMPONENTS.TOP_MOVERS) &&
                    !col.components.some((c) => c.key === SPOT_COMPONENTS.TRADE_HISTORY)
                )
              : null;
            const syncedHeight = Math.max(rowHeights[rowKey] || 882, 600);

            return (
              <Row
                key={rowKey}
                className={rowConfig.className || ""}
                style={{ margin: 0, flex: 1, alignItems: "flex-start", ...(rowConfig.style || {}) }}
              >
                {rowConfig.columns.map((colConfig, cIdx) => {
                  const isMaster = masterCol && colConfig === masterCol;
                  const isTable = hasTableCol && isTableOnlyCol(colConfig);
                  const isStackedBuySell =
                    (colConfig.colId === "col-right-buysell" ||
                      colConfig.colId === "col-left-buysell" ||
                      colConfig.colId === "col-buysell-side" ||
                      colConfig.components.some((c) => c.key === SPOT_COMPONENTS.QUICK_SWAP)) &&
                    colConfig.components.length > 1;
                  const isChartOnly =
                    colConfig.components.length === 1 &&
                    colConfig.components.some((c) => c.key === SPOT_COMPONENTS.CHART);
                  const isStackedChartOrders =
                    colConfig.components.some((c) => c.key === SPOT_COMPONENTS.CHART) &&
                    colConfig.components.some((c) => c.key === SPOT_COMPONENTS.BOTTOM_TABLE);
                  const isStackedChartMovers =
                    colConfig.components.some((c) => c.key === SPOT_COMPONENTS.CHART) &&
                    colConfig.components.some((c) => c.key === SPOT_COMPONENTS.TOP_MOVERS);
                  const shouldSyncHeight = hasChartAndBuySellInRow
                    ? !isMaster && (isTable || isStackedBuySell)
                    : (isTable || isStackedBuySell || isChartOnly || isStackedChartOrders || isStackedChartMovers);
                  const dynamicHeightStyle =
                    shouldSyncHeight && syncedHeight
                      ? { height: `${syncedHeight}px`, maxHeight: `${syncedHeight}px` }
                      : {};

                  const hasOrderBook = colConfig.components.some((c) => c.key === SPOT_COMPONENTS.ORDER_BOOK);

                  return (
                    <Col
                      key={colConfig.colId || `col-${rIdx}-${cIdx}`}
                      ref={isMaster ? (el) => registerMasterRef(rowKey, el) : undefined}
                      xs={colConfig.size?.xs || 12}
                      sm={colConfig.size?.sm}
                      md={colConfig.size?.md || 12}
                      lg={colConfig.size?.lg}
                      className={colConfig.className || "mb-1 p-0"}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        minHeight: 0,
                        overflow: hasOrderBook ? "visible" : "hidden",
                        zIndex: hasOrderBook ? 100 : 1,
                        position: "relative",
                        ...(isMaster && hasChartAndBuySellInRow ? { alignSelf: "flex-start" } : {}),
                        ...(colConfig.style || {}),
                        ...dynamicHeightStyle,
                      }}
                    >
                      {colConfig.components.map((comp) => {
                        const isChart = comp.key === SPOT_COMPONENTS.CHART;
                        const isBuySell = comp.key === SPOT_COMPONENTS.BUY_SELL;
                        const isOrderBook = comp.key === SPOT_COMPONENTS.ORDER_BOOK;
                        const isTradeHistory = comp.key === SPOT_COMPONENTS.TRADE_HISTORY;
                        const isOnlyComponent = colConfig.components.length === 1;

                        const hasChartAndBuySell =
                          colConfig.components.some((c) => c.key === SPOT_COMPONENTS.CHART) &&
                          colConfig.components.some((c) => c.key === SPOT_COMPONENTS.BUY_SELL);

                        const isStackedChartMovers =
                          colConfig.components.some((c) => c.key === SPOT_COMPONENTS.CHART) &&
                          colConfig.components.some((c) => c.key === SPOT_COMPONENTS.TOP_MOVERS);

                        const compFlex =
                          comp.flex !== undefined
                            ? comp.flex
                            : isOnlyComponent
                              ? 1
                              : hasChartAndBuySell
                                ? (isChart ? "none" : "0 0 auto")
                                : isStackedChartOrders
                                  ? (isChart ? "1.4 1 0%" : "1 1 0%")
                                  : isStackedChartMovers
                                    ? (isChart ? 1 : "none")
                                    : isBuySell
                                      ? 1
                                      : 1;
                        const compHeight =
                          comp.height !== undefined
                            ? comp.height
                            : isOnlyComponent
                              ? "100%"
                              : hasChartAndBuySell
                                ? (isChart ? "508px" : "auto")
                                : isStackedChartOrders
                                  ? (isChart ? "calc(58% - 3px)" : "calc(42% - 3px)")
                                  : isStackedChartMovers
                                    ? (isChart ? "calc(100% - 216px)" : "210px")
                                    : "50%";
                        const compMinHeight =
                          comp.minHeight !== undefined
                            ? comp.minHeight
                            : isOnlyComponent
                              ? 0
                              : hasChartAndBuySell
                                ? (isChart ? 508 : 0)
                                : isStackedChartMovers
                                  ? (isChart ? 400 : 0)
                                  : isChart
                                    ? 440
                                    : isBuySell
                                      ? 396
                                      : 0;
                        const compMaxHeight =
                          comp.maxHeight !== undefined
                            ? comp.maxHeight
                            : isStackedChartMovers && !isChart
                              ? "210px"
                              : undefined;

                        return (
                          <Box
                            key={comp.key}
                            sx={{
                              ...panelCard,
                              ...(isTradeHistory
                                ? {
                                  backgroundColor: "transparent",
                                  border: "none",
                                  borderRadius: 0,
                                }
                                : {}),
                              flex: compFlex,
                              display: "flex",
                              flexDirection: "column",
                              height: compHeight,
                              minHeight: compMinHeight,
                              maxHeight: compMaxHeight,
                              overflow: isOrderBook ? "visible" : "hidden",
                              position: "relative",
                              zIndex: isOrderBook ? 100 : 1,
                              ...(comp.sx || {}),
                            }}
                          >
                            {renderDashboardComponent(comp.key, comp)}
                          </Box>
                        );
                      })}
                    </Col>
                  );
                })}
              </Row>
            );
          })}
        </Box>

        {/* ── Binance-Style Layout Settings Drawer ── */}
        <SpotLayoutDrawer
          open={isLayoutDrawerOpen}
          onClose={() => setIsLayoutDrawerOpen(false)}
        />
      </Box>
    </DataContext.Provider>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "100vh",
  zoom: "90%",
};

// Ticker strip container (holds top stats row and bottom marquee)
const tickerStrip = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  mb: "6px",
  backgroundColor: "var(--body-color-less)",
  borderBottom: "1px solid rgba(125,125,125,0.18)",
  position: "relative",
};

const tickerTopRow = {
  display: "flex",
  alignItems: "center",
  flexWrap: { xs: "wrap", md: "nowrap" },
  justifyContent: "space-between",
  px: { xs: "12px", md: "14px" },
  py: { xs: "8px", md: "10px" },
  width: "100%",
  boxSizing: "border-box",
};

// Center stats group — takes remaining space, centers content
const tickerStatsCenter = {
  flex: { xs: "0 0 100%", md: 1 },
  width: { xs: "100%", md: "auto" },
  order: { xs: 3, md: 2 },
  mt: { xs: "8px", md: 0 },
  pt: { xs: "6px", md: 0 },
  borderTop: { xs: "1px solid rgba(125,125,125,0.12)", md: "none" },
  display: "flex",
  alignItems: "center",
  justifyContent: { xs: "flex-start", md: "center" },
  gap: { xs: "14px", md: 0 },
  overflowX: { xs: "auto", md: "hidden" },
  overflowY: "hidden",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": { display: "none" },
  WebkitOverflowScrolling: "touch",
};

const tickerPairBadge = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  pr: { md: "20px" },
  mr: { md: "4px" },
  flexShrink: 0,
  order: { xs: 1, md: 1 },
};

const tickerPairIconWrap = {
  width: 32,
  height: 32,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(125,125,125,0.18)",
  flexShrink: 0,
};


const tickerPairSub = {
  fontSize: "0.65rem",
  fontWeight: 600,
  color: "var(--text-color, #fff)",
  opacity: 0.45,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  lineHeight: 1,
  mt: "2px",
};
const tickerPairText = {
  fontSize: { xs: "0.95rem", md: "1rem" },
  fontWeight: 800,
  color: "var(--text-color)",
  letterSpacing: "0.02em",
  lineHeight: 1.2,
};


const tickerDivider = {
  width: "1px",
  height: 30,
  backgroundColor: "rgba(125,125,125,0.2)",
  mx: { xs: 0, md: "16px" },
  display: { xs: "none", md: "block" },
  flexShrink: 0,
};

const tickerStat = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  flexShrink: { xs: 0, md: 1 },
  pr: { xs: 0, md: "16px" },
  minWidth: { xs: "max-content", md: "auto" },
};

const tickerStatLabel = {
  fontSize: "0.58rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.45,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  lineHeight: 1,
  whiteSpace: "nowrap",
};

const tickerStatValue = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
  display: "flex",
  alignItems: "center",
  whiteSpace: "nowrap",
};

const tickerConnectionWrap = {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  order: { xs: 2, md: 3 },
};

const tickerConnectionPill = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  px: "10px",
  py: "4px",
  borderRadius: "20px",
  border: "1px solid rgba(125,125,125,0.2)",
  backgroundColor: "rgba(125,125,125,0.08)",
};

// Trading layout
const tradingLayout = {
  px: "6px",
  pb: "50px",
};

// Panel / card wrapper
const panelCard = {
  backgroundColor: "var(--body-color-less)",
  border: "1px solid rgba(125,125,125,0.13)",
  borderRadius: "10px",
  overflow: "hidden",
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

// Chart toggle bar
const chartToggleWrap = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  px: "8px",
  py: "6px",
  borderBottom: "1px solid rgba(125,125,125,0.13)",
  backgroundColor: "var(--body-color-less2)",
};

const chartToggleBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  px: "12px",
  py: "5px",
  borderRadius: "8px",
  border: "1px solid",
  fontSize: "0.75rem",
  cursor: "pointer",
  userSelect: "none",
  transition: "all 0.15s ease",
  letterSpacing: "0.01em",
};

export default Spot;
